import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { VisitantesRoutingModule } from './visitantes-routing.module';

import { ComponentesCompartidosModule } from '../componentes-compartidos/componentes-compartidos.module';

import { PaginaVisitantesComponent } from './pagina-visitantes/pagina-visitantes.component';

import { UsuariosService } from 'src/app/servicios/usuarios.service';
import { DetalleVisitanteComponent } from './detalle-visitante/detalle-visitante.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    PaginaVisitantesComponent,
    DetalleVisitanteComponent,
  ],
  exports: [
    PaginaVisitantesComponent
  ],
  imports: [
    MatIconModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    VisitantesRoutingModule,
    ComponentesCompartidosModule,
    MatCheckboxModule
  ],
  providers: [
    UsuariosService
  ]
})
export class VisitantesModule { }
